import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { Typography } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { store } from "store";
import { getAccessToken } from "./accessToken";
import {
  ApolloClient,
  ApolloProvider,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
  concat,
} from "@apollo/client";
import { AuthProvider } from "helpers/Auth";
import StepProvider from "context/stepContext";
import DataProvider from "context/dataContext";
require("dotenv").config();
const BASE_URL = process.env.REACT_APP_BASE_URL;
const httpLink = createHttpLink({
  uri: BASE_URL,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const accessToken = getAccessToken();


  operation.setContext(({ headers }) => ({
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : null,
    },
  }));

  return forward(operation);
});

const client = new ApolloClient({
  connectToDevTools: true,
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
  resolvers: {},
});

// add action to all snackbars
const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

ReactDOM.render(
  <SnackbarProvider
    ref={notistackRef}
    maxSnack={3}
    action={(key) => (
      <Typography
        onClick={onClickDismiss(key)}
        style={{
          fontSize: "1.2rem",
          color: "ffffff",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        'Dismiss'
      </Typography>
    )}
  >
    <Provider store={store}>
      <ApolloProvider client={client}>
        <AuthProvider>
          <StepProvider>
            <DataProvider>
              <App />
            </DataProvider>
          </StepProvider>
        </AuthProvider>
      </ApolloProvider>
    </Provider>
  </SnackbarProvider>,
  document.getElementById("root")
);
